module.exports = __webpack_public_path__ + "images/c2ba3520cdc9b0e35c3993ccf69f6b8d.png";